export const FUNCTIONAL_REPLACEMENT_COST_YEAR_THRESHOLD = 1950;

export const getFunctionalReplacementCostText = (lossSettlement, yearBuilt) => {
  if (lossSettlement === 'RC' && yearBuilt && yearBuilt <= FUNCTIONAL_REPLACEMENT_COST_YEAR_THRESHOLD) {
    return 'Building loss settlement terms will be Functional Replacement Cost';
  }
  return undefined;
};
